import { ApolloLink } from 'apollo-link'; // Import ApolloLink
import { HttpLink } from 'apollo-link-http';
import * as ls from 'local-storage';

const getProjectId = () => {
    try {
        const { pathname } = window.location;
        return pathname.split('/project/')[1].split('/')[0];
    } catch (error) {
        console.error(error);
        return null;
    }
};

const customStrapiFetch = (options) => {
    const projectId = getProjectId();

    if (projectId) {
        return `${process.env.REACT_APP_MYXP_API}/manager/livestream/showcases/graphql?projectId=${projectId}`;
    }
    return `${process.env.REACT_APP_MYXP_API}/manager/livestream/showcases/graphql`;
};

const customCrowdFlowFetch = (options) => {
    const projectId = getProjectId();

    return projectId
        ? `${process.env.REACT_APP_MYXP_API}/manager/livestream/people/graphql?projectId=${projectId}`
        : `${process.env.REACT_APP_MYXP_API}/manager/livestream/people/graphql`;
};

// Crowdflow Client
const getToken = () => {
    const auth = ls.get('auth');
    if (auth && auth.access_token) {
        return `Bearer ${auth.access_token}`;
    }
    return '';
};

// --- AUTH MIDDLEWARE ---

/**
 * This middleware intercepts every request.
 * It runs strictly before the request is sent, ensuring
 * we always grab the freshest token from localStorage.
 */
const authMiddleware = new ApolloLink((operation, forward) => {
    // 1. Get the latest token from local storage
    const auth = ls.get('auth');
    const token = auth?.access_token ? `Bearer ${auth.access_token}` : '';

    // 2. Set the headers in the operation context
    operation.setContext(({ headers = {} }) => ({
        headers: {
            ...headers,
            Authorization: token,
        },
    }));

    // 3. Forward the operation to the next link (the HttpLink)
    return forward(operation);
});

// Strapi Client
export const strapiHttp = new HttpLink({
    uri: customStrapiFetch,
    headers: {
        Authorization: getToken(),
    },
    credentials: 'include',
});

export const crowdflowHttp = new HttpLink({
    uri: customCrowdFlowFetch,
    headers: {
        Authorization: getToken(),
    },
    credentials: 'include',
});

// Chain the middleware before the HTTP link
export const strapi = authMiddleware.concat(strapiHttp);
export const crowdflow = authMiddleware.concat(crowdflowHttp);
